export default function Avatar({
    src = null,
    name = '',
    size = 'md',
    className = '',
    status = null,
    color = null
}) {
    const sizeClasses = {
        xs: { wrapper: 'avatar-xs', font: 'small' },
        sm: { wrapper: 'avatar-sm', font: 'small' },
        md: { wrapper: 'avatar', font: '' },
        lg: { wrapper: 'avatar-lg', font: 'fs-4' },
        xl: { wrapper: 'avatar-xl', font: 'fs-2' },
    };

    const getInitials = (name) => {
        if (!name) return '?';
        const words = name.trim().split(' ');
        return words.slice(0, 2).map(w => w[0]?.toUpperCase() || '').join('');
    };

    const getColor = (name) => {
        if (color) return color;
        // Solid colors - no gradients
        const colors = [
            '#6366f1', // Indigo
            '#8b5cf6', // Violet
            '#ec4899', // Pink
            '#f43f5e', // Rose
            '#f97316', // Orange
            '#eab308', // Yellow
            '#22c55e', // Green
            '#14b8a6', // Teal
            '#06b6d4', // Cyan
            '#3b82f6', // Blue
        ];
        const index = name ? name.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const statusColors = {
        online: '#28a745',
        offline: '#6c757d',
        busy: '#dc3545',
        away: '#ffc107',
    };

    return (
        <div className={`position-relative d-inline-block ${className}`}>
            {src ? (
                <img
                    src={src}
                    alt={name}
                    className={`${sizeClasses[size].wrapper} rounded-circle object-fit-cover`}
                />
            ) : (
                <div
                    className={`${sizeClasses[size].wrapper} rounded-circle d-flex align-items-center justify-content-center text-white fw-semibold ${sizeClasses[size].font}`}
                    style={{ background: getColor(name) }}
                >
                    {getInitials(name)}
                </div>
            )}
            {status && (
                <span
                    className="position-absolute bottom-0 end-0 rounded-circle border border-2 border-white"
                    style={{
                        width: size === 'xs' || size === 'sm' ? '8px' : '12px',
                        height: size === 'xs' || size === 'sm' ? '8px' : '12px',
                        backgroundColor: statusColors[status] || statusColors.offline
                    }}
                />
            )}
        </div>
    );
}
